import { logger } from 'services';
import { getTabSync } from '../tab-sync';
import { refreshPlanLanesForPhase } from './fetchers';
/** Discriminator for the plan-board lane-refresh signal. */ const PLAN_LANE_REFRESH = 'plan-lane-refresh';
/**
 * Tell other tabs that a phase's lane membership changed.
 *
 * Deliberately NOT a `planLaneCollection` entity broadcast. A lane record's
 * `pageTokens` is a paginated WINDOW over the phase's canonical order, not
 * entity data — tab A may have scrolled three pages deep where tab B has one.
 * Copying A's window into B would silently change what B is showing. Sending a
 * refresh instead keeps the server as the single ordering authority, at the
 * cost of one fetch per peer that actually has that lane loaded.
 *
 * Call after any change to which entities live in a phase: create, delete, or
 * a cross-phase move. A pure field edit does not need it — that rides on the
 * task entity itself.
 */ export const broadcastPlanLaneRefresh = (projectId, phaseId)=>{
    if (projectId == null || phaseId == null) {
        return;
    }
    getTabSync().post({
        t: 'custom',
        k: PLAN_LANE_REFRESH,
        payload: {
            projectId,
            phaseId
        }
    });
};
const isLaneRefreshPayload = (v)=>typeof v === 'object' && v !== null && typeof v.projectId === 'number' && typeof v.phaseId === 'number';
/**
 * Apply peer lane-refresh signals. `refreshPlanLanesForPhase` no-ops when this
 * tab has no lane loaded for that phase, and routes through the shared fetcher,
 * so a burst of signals collapses into one request per lane.
 */ export const attachPlanBoardTabSync = ()=>getTabSync().subscribe((msgs)=>{
        msgs.forEach((msg)=>{
            if (msg.t !== 'custom' || msg.k !== PLAN_LANE_REFRESH) {
                return;
            }
            if (!isLaneRefreshPayload(msg.payload)) {
                return;
            }
            refreshPlanLanesForPhase(msg.payload.projectId, msg.payload.phaseId).catch((error)=>logger.error('plan-board tab-sync lane refresh failed', {
                    error,
                    ...msg.payload
                }));
        });
    });
